import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import RadioGroup from '@mui/material/RadioGroup';
import styled from '@mui/material/styles/styled';

import communityBanner from '../../../assets/community-banner.png';
import planBanner from '../../../assets/plan-banner.png';
import Text from '../../elements/text/Text';

export const StyledCard = styled(Card)(({ ownerState, theme }) => ({
  height: '100%',
  backgroundImage: ownerState.isCommunity
    ? `url(${communityBanner})`
    : `url(${planBanner})`,
  backgroundSize: 'contain',
  backgroundRepeat: 'no-repeat',
  [theme.breakpoints.down('md')]: {
    backgroundColor: ownerState ? '#505050' : '#0c63a6', // matches planBanner color
  },
}));

export const StyledIconWrapper = styled('div')(({ theme }) => ({
  marginRight: 5,
  [theme.breakpoints.down('md')]: {
    color: 'white',
  },
}));

export const StyledText = styled(Text)(({ theme }) => ({
  fontSize: '0.85em',
  marginBottom: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    color: 'white',
  },
}));

export const StyledPlanText = styled(Text)({
  color: 'white',
  fontWeight: 'bold',
  fontSize: '1.25em',
});

export const StyledRadioGroup = styled(RadioGroup)({
  '& .MuiFormControlLabel-root': {
    display: 'block',
    position: 'relative',
    width: '100%',
    margin: 0,
    alignItems: 'stretch',
  },
  '& .MuiRadio-root': {
    position: 'absolute',
    right: 0,
    top: 0,
  },
});

export const StyledButton = styled(Button)(({ theme }) => ({
  position: 'absolute',
  right: 0,
  height: theme.spacing(4),
  top: theme.spacing(2.5),
  transform: 'translateY(-50%)',
}));

export const StyledTaxText = styled(Text)({
  color: 'white',
  fontSize: '0.75em',
});
